export const appsMessageArchivingSettings = "/apps/:app_group_id/message_archiving_settings" as const;
